/* eslint-disable no-console */
/* eslint-disable react/forbid-prop-types */

import { skipToken } from "@reduxjs/toolkit/dist/query";
import ClientCookies from "js-cookie";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLoadSelfQuery } from "@fdn/rtk_profile_store";

import Env from "Consts/env";
import ErrorBoundary from "Containers/error-boundary";
import { loginOrSignUp } from "Helpers/is498";
import { wrapper } from "../store";

const LoginPopup = dynamic(() => import("Components/loginpopup"), { ssr: false });
const Loader = dynamic(() => import("@fdn/loader"), { ssr: false });

function App({ Component, pageProps, err }) {

	const [isMobile, setIsMobile] = useState(false);
	const [loading, setLoading] = useState(false);
	const router = useRouter();
	const isLoginPopupShow = useSelector((state) => state.storeLoginPopup.data.isLoginPopupShow);
	useEffect(() => {

		const userAgent = navigator.userAgent || null;

		const isMobileCond = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);
		setIsMobile(isMobileCond);

	}, [setIsMobile]);

	if (typeof window !== "undefined") {

		const authorization = ClientCookies.get("token") || null;
		const customUrl = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-profile/me`;
		useLoadSelfQuery(authorization ? {
			api_env: process.env.NEXT_PUBLIC_NODE_ENV,
			customUrl,
			Authorization: authorization,
			env: Env.HEADERS,
			is_server: false,
		} : skipToken);

		useEffect(() => {

			const handleStart = () => setLoading(true); // Mulai loading saat rute berubah
			const handleComplete = () => setLoading(false); // Hentikan loading saat perubahan selesai

			// Daftarkan event untuk rute
			router.events.on("routeChangeStart", handleStart);
			router.events.on("routeChangeComplete", handleComplete);
			router.events.on("routeChangeError", handleComplete); // Hentikan jika terjadi error

			// Cleanup listeners ketika komponen unmount
			return () => {

				router.events.off("routeChangeStart", handleStart);
				router.events.off("routeChangeComplete", handleComplete);
				router.events.off("routeChangeError", handleComplete);

			};

		}, [router]);

	}

	return (
		<ErrorBoundary>
			{isLoginPopupShow && (
				<LoginPopup
					onButtonClick={loginOrSignUp}
					show={isLoginPopupShow}
					isMobile={isMobile}
				/>
			)}
			<Component {...pageProps} err={err} />
			{loading && (
				<>
					<div className="fdn-loader">
						<Loader />
					</div>
					<style>
						{`
							.fdn-loader {
								position:absolute;
							}
						`}
					</style>
				</>
			)}
		</ErrorBoundary>
	);

}

App.propTypes = {
	Component: PropTypes.func.isRequired,
	pageProps: PropTypes.objectOf(PropTypes.any).isRequired,
	err: PropTypes.objectOf(PropTypes.any),
};

App.defaultProps = {
	err: {},
};

// export default App
export default wrapper.withRedux(App);
